import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
export interface AuditedOrgResponse {
  lastAudited: string
}
export async function auditOrganization (orgId: number): Promise<HttpResponse<AuditedOrgResponse>> {
  return await handleHttpRequest(http.post(`/api/v1/organizations/${orgId}/audit/`))
}
